export default "__VITE_ASSET__sthtrQVE__"